<template>
  <form-field-radio-buttons
    :radio-class="tempClass"
    :items="availableTemps"
    v-model="value"
    expanded
    @change="changeTempClass"
    style="min-width: 260px"
  ></form-field-radio-buttons>
</template>

<script>
import {ENUMS} from "../../services/enums";

export default {
  name: "RecordTemperatureButtons",
  props: {
    recordId: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      tempClass: "",
      availableTemps: [
        {
          value: ENUMS.TemperatureEnum.None.value,
          label: ENUMS.TemperatureEnum.None.label
        },
        {
          value: ENUMS.TemperatureEnum.Cold.value,
          label: ENUMS.TemperatureEnum.Cold.label
        },
        {
          value: ENUMS.TemperatureEnum.Warm.value,
          label: ENUMS.TemperatureEnum.Warm.label
        },
        {
          value: ENUMS.TemperatureEnum.Hot.value,
          label: ENUMS.TemperatureEnum.Hot.label
        },
      ]
    };
  },
  created() {
    this.setTempClass(this.value);
  },
  watch: {
    value() {
      this.setTempClass(this.value);
    },
  },
  methods: {
    setTempClass(temp) {
      if (temp === ENUMS.TemperatureEnum.None.value) this.tempClass = "temp_is_none";
      if (temp === ENUMS.TemperatureEnum.Cold.value) this.tempClass = "temp_is_cold";
      if (temp === ENUMS.TemperatureEnum.Warm.value) this.tempClass = "temp_is_warm";
      if (temp === ENUMS.TemperatureEnum.Hot.value) this.tempClass = "temp_is_hot";
    },
    changeTempClass(value) {
      this.setTempClass(value);

      const data = {temperature: value}
      this.$api.records.setTemperature(this.recordId, data)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Lead temperature has been updated',
            type: 'is-success'
          });
        })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

// This styles the radio buttons
::v-deep {
  .temp_is_none .b-radio.radio.button.is-light {
    color: $text;
  }
  .temp_is_cold .b-radio.radio.button.is-light {
    color: $blue;
  }
  .temp_is_warm .b-radio.radio.button.is-light {
    color: $amber;
  }
  .temp_is_hot .b-radio.radio.button.is-light {
    color: $red;
  }

  .b-radio.radio.button {
    background-color: $white;
    color: $text-muted;
    font-weight: bold;

    &.is-light {
      background-color: $light-grey;
    }

    &.is-focused,
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
